const opcDaWriterHu = {
	opcDaWriterTable: 'OPC DA Writer',
	opcDaWriterLog: 'OPC DA Writer Log',
	opcDaWriterEditForm: 'OPC DA Writer',
	name: 'Name',
	serverName: 'Server Name',
	hostName: 'Host Name',
	user: 'User',
	type: 'Type',
	tagName: 'Tag Name',
	basic: 'Basic',
	fields: 'Fields',
	userGroup: 'User Group',
	expression: 'Expression',
};

export default opcDaWriterHu;
